var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-table',{attrs:{"url":"/api/v1/automaticMessageRule","filter":[{ name: 'with', value: 'customerProfile' }],"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        name: 'Profil',
        type: 'ProfileCell'
      },
      {
        attribute: 'send_to_gender',
        name: 'Sende an',
        type: 'MultiSexCell'
      },
      {
        attribute: 'message',
        name: 'Nachricht(en)',
        type: 'MessagePoolCell'
      },
      {
        attribute: 'send_to_users_with_dialogues',
        name: 'Bei Dialogen senden?',
        type: 'CheckMarkerCell'
      },
      {
        attribute: 'active',
        name: 'Aktiv?',
        type: 'ToggleCell',
        url: 'toggle_disable_url'
      },
      {
        attribute: 'update_page_url',
        name: 'Anpassen',
        type: 'ActionCell',
        sortable: false
      },
      {
        attribute: 'update_url',
        name: 'Entfernen',
        type: 'DeleteCell',
        label: 'Löschen',
        sortable: false
      }
    ]}}),_vm._v(" "),_c('v-table',{attrs:{"url":"/api/v1/automaticMessageRuleLog","attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'rule_id',
        name: 'Regel'
      },
      {
        name: 'Benutzer',
        type: 'LinkProfileCell',
        attribute: 'message.receiver',
        sortable: false
      },
      {
        name: 'Fake',
        type: 'ProfileCell',
        attribute: 'message.sender',
        sortable: false
      },
      {
        attribute: 'created_at',
        name: 'Erstellt am',
        type: 'DateTimeCell'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }